
// Check if variable is numeric
export const isNumeric = (value: unknown): boolean => {
    const string = typeof value === "string" ? value.trim() : value;
    const number = Number(string);
    return Number.isFinite(number);
};
